import React, { useEffect, useRef, useState } from 'react';
import { prop } from 'ramda';
import { requestSubscription, useRelayEnvironment } from 'react-relay';
import useUserRefreshLock from '../hooks/useUserRefreshLock';
import ModalLoading from './ModalLoading';

const ProgressModalSubscription = ({
  isOpen,
  subscription,
  variables,
  infoLoading,
  onFinish,
  extractStatus,
  initialStatus,
  setIsOpen,
  error
}) => {
  const environment = useRelayEnvironment();

  const [status, setStatus] = useState(initialStatus);
  const lastSequenceRef = useRef(0);
  const { lockUserRefresh, unlockUserRefresh } = useUserRefreshLock();

  const progress = prop('step', status) > 0 ? Math.floor(prop('step', status) * 100) : 0;

  useEffect(() => {
    if (isOpen) {
      lockUserRefresh();
    } else {
      unlockUserRefresh();
    }
  }, [isOpen, lockUserRefresh, unlockUserRefresh]);

  useEffect(() => {
    if (isOpen) {
      const sub = requestSubscription(environment, {
        subscription,
        variables,
        onNext: (response) => {
          const statusData = extractStatus(response);
          if (statusData && statusData.sequence > lastSequenceRef.current) {
            setStatus(prev => ({ ...prev, ...statusData }));
            lastSequenceRef.current = statusData.sequence;
          }
        },
        onError: (error) => console.error('Subscription error:', error)
      });
      return () => sub.dispose();
    }
  }, [environment, extractStatus, isOpen, subscription, variables]);

  const handleClick = () => {
    onFinish();
    setStatus(initialStatus);
    setIsOpen(false);
  };

  return (
    <ModalLoading
      visible={isOpen}
      onClick={handleClick}
      progress={progress}
      infoLoading={infoLoading(status, progress, error)}
      textProgression={`${progress}%`}
    />
  );
};

export default ProgressModalSubscription;
